import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { PhoenixPipesModule } from '../../../pipes/pipes';
import { ComponentsModule } from 'app/components/components.module';
import { AuthGuardService } from 'app/shared/services/auth-guard.service';
import { SubjectModule } from '../subjects/subject.module';
import { CdkTableModule } from '@angular/cdk/table';
import { WidgetModule } from 'app/main/widgets/widget.module';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';
import { SharedModule } from 'app/shared/shared.module';
import { ThemeEmitterModule } from 'app/components/theme-emitter/theme-emitter.module';
import { WidgetService } from 'app/main/widgets/widget.service';
import { CardWidgetsModule } from 'app/main/widgets/card-widgets/card-widgets.module';
import { ReferralsComponent } from './referrals/referrals.component';
import { EntitiesModule } from '../entities/entities.module';
import { ReferralSubjectDashboardComponent } from './referral-subject-dashboard/referral-subject-dashboard.component';
import { CanDeactivateGuard } from 'app/shared/guards/can-deactivate.guard';
import { SimpleContactDetailsComponent } from './simple-contact-details/simple-contact-details.component';
import { ReferralDialogComponent } from './referral-dialog/referral-dialog.component';
import { SubjectComponentsModule } from '../subjects/subject-components.module';
import { ReviewDialogComponent } from './review-dialog/review-dialog.component';
import { SubjectService } from 'app/shared/services/subject.service';
import { DateModule } from '../misc/date.module';

const routes = [
    {
        path: 'referrals/all',
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            result: SubjectService,
        },
    },
    {
        path: 'referrals/u/:user',
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            result: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user',
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            result: SubjectService,
        },
    },
    {
        path: 'referrals/archived',
        exactMatch: true,
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/duefordeletion',
        exactMatch: true,
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        canActivate: [AuthGuardService],
        data: { auth: 'ADMIN,USER,READONLY,ORGMANAGER,MULTIORGADMIN' },
        resolve: {
            result: SubjectService,
        },
    },
    // {
    //     path: 'referrals/:subjecttype/u/:user/:organisation',
    //     exactMatch: true,
    //     component: ReferralsComponent,
    //     children: [],
    //     resolve: {
    //         files: SubjectService,
    //     },
    // },
    {
        path: 'referrals/:subjecttype/u/:user/state/:state',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/state/:state/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/category/:category',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/category/:category/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/caseType/:caseType',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/caseType/:caseType/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/status/:status',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/status/:status/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/subject/:id',
        component: ReferralSubjectDashboardComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path: 'referrals/:subjecttype/u/:user/reviewDays/:reviewDays',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    },
    {
        path: 'referrals/:subjecttype/u/:user/reviewDays/:reviewDays/:organisation',
        exactMatch: true,
        component: ReferralsComponent,
        children: [],
        resolve: {
            files: SubjectService,
        },
    }

];

@NgModule({
    declarations: [
        ReferralsComponent,
        ReferralDialogComponent,
        ReviewDialogComponent,
        ReferralSubjectDashboardComponent,
        SimpleContactDetailsComponent,
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        MatListModule,
        MatProgressBarModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MatDividerModule,
        MatTooltipModule,
        ComponentsModule,
        CommonModule,
        PhoenixPipesModule,
        FuseSharedModule,
        PhoenixDirectivesModule,
        SubjectModule,
        CdkTableModule,
        MatIconModule,
        MatButtonModule,
        MatRippleModule,
        MatSlideToggleModule,
        MatSidenavModule,
        MatTableModule,
        MatInputModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatSortModule,
        MatTabsModule,
        MatToolbarModule,
        MatMenuModule,
        MatStepperModule,
        MatTooltipModule,
        MatDividerModule,
        WidgetModule,
        CardWidgetsModule,
        GridsterModule,
        DynamicModule,
        ComponentsModule,
        FuseSharedModule,
        SharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule.forRoot(),
        ThemeEmitterModule,
        EntitiesModule,
        SubjectComponentsModule,
        DateModule,
    ],
    providers: [
        WidgetService,
    ],
    exports: []
})
export class ReferralsModule {
}
